import { useApiQuery } from './useApiQuery';
import { clientsApi } from '@/api/clients';
import type { ClientListResponse } from '@/api/clients';

interface UseClientsOptions {
  partnerId?: string;
  search?: string;
  enabled?: boolean;
}

export const useClients = (options: UseClientsOptions = {}) => {
  const { partnerId, search, enabled = true } = options;

  const { data, isLoading, error, isUsingMockData, reload } = useApiQuery<ClientListResponse>(
    {
      queryFn: () => clientsApi.list({ partnerId, search }),
      enabled,
    },
    [partnerId, search],
  );

  return {
    clients: data?.clients ?? [],
    total: data?.total ?? 0,
    isLoading,
    error,
    isUsingMockData,
    reload,
  };
};
